export function numericRule() {
    return function (input) { return /^\d+$/.test(input) || "数字のみで入力してください"; };
}
//# sourceMappingURL=numeric.js.map